<template>
    <div class="box-card">
        <h1>
            {{data.transDate.slice(5)}}竞猜结果 <br>
            <template v-if="data.upDown > 0 ">
                <small v-if="data.upDown === data.betType">恭喜您预测成功！{{data.transDate.slice(5)}} 上证综指收盘为：
                    <span v-if="data.upDown === 1" class="upColor">涨</span>
                    <span v-else-if="data.upDown===2" class="downColor">跌</span>
                </small>
                <small v-else>很遗憾，{{data.transDate.slice(5)}}上证综指涨跌预测错误啦！亏损{{data.rewardGold}}金币</small>
            </template>
            <small v-else>竞猜结果将于 {{data.transDate.slice(5)}} {{baseConf.resultTime}}后揭晓，敬请期待！</small>
        </h1>
        <dl class="m-dl fts-28">
            <dt><span class="fts-24">投注时间：</span> <span class="cl-black fts-28">{{data.ctime}}</span>  <span class="cl-red fts-28"> {{data.upDown > 0 ? '已收盘':'未收盘'}}</span></dt>
            <dd><span class="fts-24">名称：</span><strong class="cl-black fts-28">上证综指</strong></dd><dd class="cl-black fts-28" style="padding-left:0.75rem;"> {{data.transDate.slice(0,10)}}</dd>
            <dd><span class="fts-24">投注：</span>
                    <span class="upColor fts-28" v-if="data.betType===1">押涨↑</span>
                    <span class="downColor fts-28" v-else-if="data.betType===2">押跌↓</span>
            </dd>
            <dd><span class="fts-24">数额：</span> <span class="cl-black fts-28">{{data.betNum}}注(<k-num :value="data.betNum*100"></k-num><i class="icon-gold"></i>)</span></dd>
            <dd><span class="fts-24">收盘：</span>
                <span class="upColor fts-28" v-if="data.upDown===1">涨</span>
                <span class="downColor fts-28" v-else-if="data.upDown===2">跌</span>
                <span v-else>--</span>
            </dd>
            <dd><span class="fts-24">盈亏：</span>
                <span class="cl-black fts-28" v-if="data.upDown===1"><k-num :value="data.rewardGold" :sign="true"></k-num></span>
                <span class="cl-black fts-28" v-else-if="data.upDown===2"><k-num :value="data.rewardGold" :sign="true"></k-num></span>
                <span class="cl-black fts-28" v-else>进行中</span>
            </dd>
        </dl>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    export default {
        props:{
            data : {
                type : Object,
                default : null
            },
            state: Number,
            type : String
        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapState('home', ['baseConf'])
        },
    }
</script>